//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import vComponent from '@/core/vComponent'
import { userInfo, searchVipBar } from './components'
import { mainCat, subCat, recentBuy, department } from './report'
export default {
  name: 'ReportPage',
  extends: vComponent,
  components: { mainCat, subCat, recentBuy, department, userInfo, searchVipBar },
  data () {
    return {
      defaultTab: 'subCat', // 預設起始tab
      selectedTab: '',
      tabs: [
        { id: 'mainCat', label: '大分類' },
        { id: 'subCat', label: '中分類' },
        { id: 'department', label: '商品部門' },
        { id: 'recentBuy', label: '最近購買' }
      ],
      mainCatItems: [], // 大分類
      subCatItems: [], // 中分類
      departmentItems: [], // 產品部門
      recentBuyItems: [] // 最近購買
    }
  },
  computed: {
    ...mapGetters([
      'theme'
    ]),
    selectedTabLabel () {
      let label = ''
      this.tabs.forEach(tab => {
        if (tab.id === this.selectedTab) label = tab.label
      })
      return label
    }
  },
  created () {
    this.selectedTab = this.defaultTab
  },
  mounted () {
  },
  watch: {
    selectedTab (val, oldVal) {
      switch (val) {
        case 'mainCat':
          this.queryＭainCat()
          break
        case 'subCat':
          this.querySubCat()
          break
        case 'recentBuy':
          this.queryRecentBuy()
          break
        case 'department':
          this.queryDepartment()
          break
      }
    }
  },
  methods: {
    clickBtn (row, type) {
      if (type === 'recommend') {
        console.log(`open ${row.VIP_CODE} recommend modal`)
      } else {
        const url = `/vip/${row.VIP_CODE}/${type}`
        this.to(url)
      }
    },
    clieckTab (index) {

    },
    // 查大分類
    async queryＭainCat () {
      const data = {
        T_VIP: this.params.vipcode
      }
      const response = await this.fetch('getCustAnz1', data)
      this.mainCatItems = response.data !== null ? response.data : []
    },
    // 查中分類
    async querySubCat () {
      const data = {
        T_VIP: this.params.vipcode
      }
      const response = await this.fetch('getCustAnz2', data)
      this.subCatItems = response.data !== null ? response.data : []
    },
    // 查產品部門
    async queryDepartment () {
      const data = {
        T_VIP: this.params.vipcode
      }
      const response = await this.fetch('getCustAnz3', data)
      this.departmentItems = response.data !== null ? response.data : []
    },
    // 查最近購買
    async queryRecentBuy () {
      const data = {
        T_VIP: this.params.vipcode
      }
      const response = await this.fetch('getCustAnz4', data)
      this.recentBuyItems = response.data !== null ? response.data : []
    }
  }
}
